import { render, staticRenderFns } from "./send-spin-stat.vue?vue&type=template&id=81b6b13e&scoped=true&"
import script from "./send-spin-stat.vue?vue&type=script&lang=js&"
export * from "./send-spin-stat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b6b13e",
  null
  
)

export default component.exports